export default __webpack_public_path__ + "static/media/ufal.3346d9e8.svg";